import { BarChart3 } from "lucide-react";
import { Panel, EmptyState } from "@/components/admin/ui";

export const BillingReportingTab = () => (
  <div data-testid="billing-reporting-tab">
    <Panel title="Billing Reporting" subtitle="Deeper revenue, aging and collections analytics.">
      <EmptyState
        icon={BarChart3}
        title="Coming soon."
        message="Detailed billing reports (aging, revenue by service, collection rate trends) will appear here as more invoicing history builds up."
        testId="billing-reporting-empty"
      />
    </Panel>
  </div>
);
